export enum OrderRequestType {
    Ascending = "Ascending",
    Descending = "Descending"
}
